import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialSourceColumnWarehouseSlice = [] as any

const sourceColumnWarehouseSlice = createSlice({
  name: 'sourceColumnWarehouseSlice',
  initialState: initialSourceColumnWarehouseSlice,
  reducers: {
    setSourceColumnWarehouse: (state, action: PayloadAction<any>) => action.payload,
    clearSourceColumnWarehouse: (state) => initialSourceColumnWarehouseSlice
  }
})

export const selectorSourceColumnWarehouse = (state: { sourceColumnWarehouseSlice: any }) => state.sourceColumnWarehouseSlice;
export const { setSourceColumnWarehouse, clearSourceColumnWarehouse } = sourceColumnWarehouseSlice.actions;
export default sourceColumnWarehouseSlice.reducer;
